import React, { useState, useContext } from 'react';
import BookerContext from '../../context/bookerContext';
import '../../assets/styles/ride-later-overlay.sass';
import Picker from 'react-mobile-picker-scroll';
import { format, add, endOfToday, roundToNearestMinutes, startOfTomorrow, endOfTomorrow, startOfDay } from 'date-fns';
import { mixpanelEventTrack, registerMixpanelEvent } from '../../services/mixpanel';
import { ReactComponent as CalendarIcon } from '../../assets/img/calendar-icon.svg';
import { ReactComponent as CalendarIconBlack } from '../../assets/img/calendar-icon-black.svg';
import CancelRide from '../RideComponents/CancelRide';

const RideLater = () => {
  const [isOpenOverLay, setIsOpenOverLay] = useState(false);

  const nearestFifteen = roundToNearestMinutes(new Date(), { nearestTo: 15 });
  const finalStartTime = format(nearestFifteen, 'yyyy-MM-dd HH:mm:ss aaaa');
  const result = add(nearestFifteen, { hours: 48 });
  const finalEndTime = format(result, 'yyyy-MM-dd HH:mm:ss aaaa');

  const nowStartTime = finalStartTime;
  const nowEndTime = format(add(new Date(), { minutes: 15 }), 'yyyy-MM-dd HH:mm:ss aaaa');

  const todayStartTime = nowStartTime;
  const todayEndTime = format(endOfToday(), 'yyyy-MM-dd HH:mm:ss aaaa');

  const tomorrowStartTime = format(startOfTomorrow(), 'yyyy-MM-dd HH:mm:ss aaaa');
  const tomorrowEndTime = format(endOfTomorrow(), 'yyyy-MM-dd HH:mm:ss aaaa');

  const lastDayStartTime = format(startOfDay(new Date(result)), 'yyyy-MM-dd HH:mm:ss aaaa');
  const lastDayEndTime = finalEndTime;

  let [startTime, setStartTime] = useState(finalStartTime);
  let [endTime, setEndTime] = useState(nowEndTime);
  const thisYear = new Date().getFullYear();

  const TodayString = `Today, ${format(nearestFifteen, 'MMM d')}`;
  const TomorrowString = `Tomorrow, ${format(startOfTomorrow(), 'MMM d')}`;
  const LastDayString = format(result, 'MMM d');

  const context = useContext(BookerContext);

  let {
    state: { rideId, pickup, dropoff, step, rideLater = {}, isWebBooker },
  } = context;
  const { updateRideLater, updateStep } = context;

  let isUpcomingRideInfoStep = (isWebBooker && step === 13) || (!isWebBooker && step === 10);

  //-----------------------------------------------

  //Parse In
  const parseIn = function (date_time) {
    const d = new Date();
    d.setHours(date_time.substring(11, 13));
    d.setMinutes(date_time.substring(14, 16));
    return d;
  };

  //make list
  const getTimeIntervals = function (time1, time2) {
    const arr = [];
    while (time1 < time2) {
      const oldTime = time1.toLocaleString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
      });
      time1.setMinutes(time1.getMinutes() + 15);
      arr.push(
        oldTime +
          ' - ' +
          time1.toLocaleString('en-US', {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
          }),
      );
    }
    return arr;
  };

  startTime = parseIn(startTime);
  endTime = parseIn(endTime);

  const intervals = getTimeIntervals(startTime, endTime);

  //-----------------------------------------------------------------

  const [optionGroups, setOptionGroups] = useState({
    Day: ['Now', TodayString, TomorrowString, LastDayString],
    TimeInterval: intervals,
  });
  const [valueGroups, setvalueGroups] = useState({
    Day: 'Now',
    TimeInterval: intervals,
  });

  const getPickupTime = pickupTime => {
    const pickupTimeDate = new Date(pickupTime);
    const { text: pkd = null, simple: pks = {}, pickupAlias = null } = pickup || {};
    const pickupLocation = {
      line1: pks?.line1,
      city: pks?.city,
      state: pks?.state,
      postal_code: pks?.postalCode,
      displayed_address: pkd || null,
      alias: pickupAlias ? pickupAlias : null,
      latitude: !pickupAlias ? pks.latitude : null,
      longitude: !pickupAlias ? pks.longitude : null,
    };
    // this should send time in utc for pickup location, not device location
    // if tz offset or utc_offset are NaN, the addition will return NaN and it will default to 0
    // so if utc_offset is not defined, null, or bad format, no offset will be used.
    // In this case somebody booking rides in another tz will have book in the local tz (booked in chicago at 2am will trigger a ride at 3am in nyc)
    const offset_from_local = (pickupTimeDate.getTimezoneOffset() + parseInt(pickupLocation.utc_offset)) * 60000 || 0;
    const millis = pickupTimeDate.getTime() - offset_from_local;
    const pickup_time = millis / 1000;
    const pickup_time_in_millis = millis;
    console.log('pickup_time', pickup_time);
    return {
      pickup_time: pickup_time,
      pickup_time_offset_from_local: offset_from_local,
      pickup_time_in_millis: pickup_time_in_millis,
    };
  };

  const getRideLaterObj = (strArray, timeIntervalArray, timeInterval, dayName) => {
    return {
      isLater: dayName !== 'Now',
      day: dayName || '',
      weekday: strArray[0],
      date: strArray[1],
      time: dayName === 'Now' ? strArray[2] : timeIntervalArray[0],
      timeInterval: timeInterval || null,
      pickupTime: dayName === 'Now' ? null : getPickupTime(`${strArray[1]}, ${thisYear}, ${timeIntervalArray[0]}`),
    };
  };

  const getRideStringLater = (day, timeInterval) => {
    let obj, str, strArray, timeIntervalArray, dayName;

    if (day.includes('Now')) {
      str = format(nearestFifteen, 'EEE, MMM dd, HH:mm aa');
      timeIntervalArray = timeInterval ? timeInterval[0].split('-') : null;
      dayName = 'Now';
    } else if (day.includes('Today')) {
      str = format(nearestFifteen, 'EEE, MMM dd,HH:mm aa');
      dayName = 'Today';
    } else if (day.includes('Tomorrow')) {
      str = format(startOfTomorrow(), 'EEE, MMM dd,');
      dayName = 'Tomorrow';
    } else {
      str = format(result, 'EEE, MMM dd,');
      dayName = '';
    }

    strArray = str.split(',');
    if (!day.includes('Now')) timeIntervalArray = timeInterval.split('-');
    obj = getRideLaterObj(strArray, timeIntervalArray, timeInterval, dayName);
    return obj;
  };

  const [rideLaterString, setRideLaterString] = useState(getRideStringLater('Now'));

  const setValuesToDisplayOnPopup = (startTime, endTime, name, value, valueName) => {
    setStartTime(startTime);
    setEndTime(endTime);
    startTime = parseIn(startTime);
    endTime = parseIn(endTime);
    const t = getTimeIntervals(startTime, endTime);
    setOptionGroups({
      Day: ['Now', TodayString, TomorrowString, LastDayString],
      TimeInterval: t,
    });
    setvalueGroups({ ...valueGroups, [name]: value });
    setRideLaterString(getRideStringLater(valueName, valueGroups.TimeInterval));
  };

  const handleChange = (name, value) => {
    let startTime, endTime, dayName;
    if (name === 'Day') {
      if (value === 'Now') {
        startTime = nowStartTime;
        endTime = nowEndTime;
        dayName = 'Now';
      } else if (value.includes('Today')) {
        startTime = todayStartTime;
        endTime = todayEndTime;
        dayName = 'Today';
      } else if (value.includes('Tomorrow')) {
        startTime = tomorrowStartTime;
        endTime = tomorrowEndTime;
        dayName = 'Tomorrow';
      } else if (value.includes(LastDayString)) {
        startTime = lastDayStartTime;
        endTime = lastDayEndTime;
        dayName = LastDayString;
      }
      setValuesToDisplayOnPopup(startTime, endTime, name, value, dayName);
    } else {
      setvalueGroups({ ...valueGroups, [name]: value });
      setRideLaterString(getRideStringLater(valueGroups.Day, value));
    }
  };

  const openRideLater = () => {
    if (step === 13) return;
    mixpanelEventTrack('rideLaterSelectedWebBook');
    if (!isWebBooker && step === 9) return;
    if (rideLater.isLaterRideBooked) {
      //show upcoming ride details screen
      updateStep(isWebBooker ? 13 : 10);
    } else {
      setIsOpenOverLay(true);
    }
  };

  const handleRideLater = () => {
    updateRideLater({ ...rideLaterString, pickup: pickup, dropoff: dropoff, isLaterRideBooked: false });
    setIsOpenOverLay(false);
  };

  const handleCancelRideLater = () => {
    updateRideLater({});
    setIsOpenOverLay(false);
  };

  return (
    <>
      <a className="ride-later-button" onClick={openRideLater}>
        {isUpcomingRideInfoStep ? <CalendarIconBlack /> : <CalendarIcon />}
        <span className="ride-later-btn-text">
          {rideLater.isLaterRideBooked || rideLater.isLater ? 'UPCOMING RIDE' : 'RIDE LATER'}
        </span>
        {(rideLater.isLaterRideBooked || rideLater.isLater) && (
          <p>
            {rideLater.date}, {rideLater.timeInterval}
          </p>
        )}
      </a>
      {isUpcomingRideInfoStep && <CancelRide />}
      <div>
        {isOpenOverLay && (
          <div className={`popup-overlay  ride-later`}>
            <div className="ride-later-container">
              <div className="ride-later-title-container">
                <div className="ride-later-title">Select a date and time for your upcoming ride </div>
                <div className="time-selected">
                  {rideLaterString.weekday}, {rideLaterString.date}, {rideLaterString.time}
                </div>
              </div>
              <div className="ride-later-body">
                <Picker disabled optionGroups={optionGroups} valueGroups={valueGroups} onChange={handleChange} />
              </div>
              <div className="ride-later-footer">
                <div className="ride-later-btn-secondary" onClick={handleCancelRideLater}>
                  CANCEL
                </div>
                <div className="ride-later-btn-default" onClick={handleRideLater}>
                  OK
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default RideLater;
